<div id="asp-calendar">
  <mat-card appearance="outlined" class="demo-inline-calendar-card" [ngClass]="isDashBoard() ? 'dashboard-color' : '' ">
    <mat-calendar #tdcalendar
                  [headerComponent]="customHeader"
                  [(selected)]="selectedDate"
                  [dateFilter]="dateFilterInput"
                  [startAt]="startAt"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [dateClass]="setDateClass"
                  (selectedChange)="dateChange($event)"
                  (monthSelected)="monthChange($event)"
                  [ngClass]="{'loading': isAvailabilityLoading}"
                  (click)="clickEvent('click', $event)"
                  class="col-md-12">
    </mat-calendar>
  <div class="leave-type-container">
    <div class="leave-type-identifier" *ngFor="let leave of leavesLegend">
      <div class="square {{leave.name}}"></div>
      <span [ngClass]="source==='dashboard'? 'dashboard-leave-name': 'leave-name'">{{getTranslation(leave.name)}}</span>
    </div>
  </div>
</mat-card>

  <div class="calendar-skeleton"
       *ngIf="isAvailabilityLoading"></div>
</div>
